import styles from "./SavedViewWithMonitoringPage.module.scss";
import { useSelector } from "react-redux";
import {
  getIsSavedViewsLoading,
  getSavedViews,
} from "../../../../redux/SingleDataset/selectors";
import { SavedViewsTable } from "./SavedViewsTable";
import { SavedViewsSkeleton } from "../SavedViewsSkeleton";
import { NoViewsComponent } from "../NoViewComponent";

export const SavedViewWithMonitoringPage = ({
  datasetId,
}: {
  datasetId: string;
}) => {
  const views = useSelector(getSavedViews);
  const isLoading = useSelector(getIsSavedViewsLoading);
  return (
    <div className={styles.SavedViewWithMonitoringPage}>
      <div className={styles.main}>
        {isLoading ? (
          <SavedViewsSkeleton />
        ) : !views.length ? (
          <NoViewsComponent />
        ) : (
          <SavedViewsTable views={views} datasetId={datasetId} />
        )}
      </div>
    </div>
  );
};
